import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import { HttpClient, HttpHeaders} from "@angular/common/http";
import {STORAGE} from "../../constants/local-storage.constants";

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  /** Region: Variable Declaration */
  private readonly API_URL: string = environment.API_URL;
  private readonly CLIENT_ID: string = environment.CLIENT_ID;
  private readonly CLIENT_SECRET: string = environment.CLIENT_SECRET;
  private readonly GRANT_TYPE: string = environment.GRANT_TYPE;
  /** End Region */

  /** Region: Constructor */
  constructor(private http: HttpClient) { }
  /** EndRegion */

  get(url: string, requestParamModel?: any) {
    const fullURL = this.getURL(url, requestParamModel);
    const headers = this.getHeaders();
    return this.http.get(fullURL, {
      headers: headers,
      observe: 'response'
    });
  }

  /**
   *
   */
  getDownloadFileContent(url: string,) {
    const fullURL = this.API_URL + this.getURL(url);
    return fullURL;
  }

  /**
   * @description This method is used for the prepare the endpoint
   * @param url
   * @param requestParamModel
   * @private
   */
  private getURL(url: string, requestParamModel?: any): string {
    let newURL: string = url;
    if (requestParamModel) {
      newURL += requestParamModel.getParams();
    }
    return newURL;
  }

  /**
   * @description This method is used for the getting headers for the request
   * @param authorizationHeader
   * @private
   */
  private getHeaders(authorizationHeader: boolean = true): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('accept', 'application/json');
    headers = headers.append('Content-Type', 'application/json');
    if (typeof window != 'undefined' && authorizationHeader && localStorage.getItem(STORAGE.TOKEN_KEY)) {
      headers = headers.append('Authorization', this.getAccessToken());
    }
    return headers;
  }

  /**
   * @description This method is used for the getting access token from local storage
   * @private
   */
  private getAccessToken(): string {
    const token = localStorage.getItem(STORAGE.TOKEN_KEY);
    return 'Bearer ' + token;
  }
  post(url: string, bodyModel: any) {
    const fullURL = this.getURL(url);
    const headers = this.getHeaders();
    return this.http.post(fullURL, bodyModel, {
      headers: headers
    });
  }

  uploadPost(url: string, bodyModel: any) {
    const fullURL = this.getURL(url);
    let headers: HttpHeaders = new HttpHeaders();

    if (localStorage.getItem(STORAGE.USER_KEY)) {
      headers = headers.append('Authorization', this.getAccessToken());
    }
     return this.http.post(fullURL, bodyModel, {
      headers: headers,  // Do not add Content-Type header manually
    });
  }

}
